// src/components/Avatar.js
import React, { useState } from 'react'; // <-- Импортируем useState
import { getLevelFromXp } from '../utils/levelManager';

export default function Avatar({ user, className, xp }) {
  // --- НОВОЕ: Состояние для отслеживания ошибки загрузки ---
  const [hasError, setHasError] = useState(false);

  if (!user) {
    return <div className={`avatar-container placeholder ${className || ''}`} data-letter="?"></div>;
  }
  
  const firstLetter = (user.serverNickname || user.username || '?').charAt(0).toUpperCase();
  const avatarUrl = user.avatar ? `https://cdn.discordapp.com/avatars/${user.id}/${user.avatar}.png` : null;

  const level = xp !== undefined ? getLevelFromXp(xp) : 0;
  const highlightClass = level >= 15 ? 'veteran-highlight' : '';

  // Функция, которая будет вызвана, если img не сможет загрузиться
  const handleError = () => {
    setHasError(true);
  };

  // --- ИЗМЕНЕНИЕ: Добавляем класс 'placeholder', если есть ошибка или нет URL ---
  const containerClasses = `avatar-container ${className || ''} ${highlightClass} ${!avatarUrl || hasError ? 'placeholder' : ''}`;

  return (
    <div 
      className={containerClasses}
      data-letter={firstLetter}
    >
      {avatarUrl && !hasError && (
        <img src={avatarUrl} alt={user.username} onError={handleError} />
      )}
    </div>
  );
}